

















import Vue from 'vue';

export default Vue.extend({
  name: 'OComponentDemo',
  props: {
    title: String,
    data: Object,
  },
  data() {
    return {
      showData: false,
    };
  },
});
